import React from 'react';
import BackdropWrapper from '../common/BackdropWrapper';
import { withRouter } from "react-router";
import { CircleButton, Icon, Typography } from '../ecosystem'

class MyChartProxyButton extends React.Component {
    constructor(props) {
        super(props);
        this.updateProxyButtonToolTipPreference = this.updateProxyButtonToolTipPreference.bind(this)
    }

    componentDidMount() {

    }

    updateProxyButtonToolTipPreference() {
        const { updateFamilyManagementToolTipPreference } = this.props;
        if (updateFamilyManagementToolTipPreference)
            updateFamilyManagementToolTipPreference();
    }

    render() {
        const { enableFamilyManagementTooltip } = this.props;
        
        return (
            <BackdropWrapper onClickBackdrop={this.updateProxyButtonToolTipPreference}
                align="bottom"
                containerClass="mychart-btn-tooltip"
                toolTipInfo="Now there's an even easier way to add and manage your family's healthcare."
                okBtnText="GOT IT!"
                scrollIntoView
                showTooltip={enableFamilyManagementTooltip}
                wrapperClass={`mychart-proxy-btn-container`}
            >
                <CircleButton colorStyle='default'
                    icon="plus"
                    size="small"
                    onClick={(e) => {  this.props.onClick(e); }}
                    color="$color-interaction-active-border" />
                {/*<button className="proxy-btn btn btn-icon" onClick={this.props.onClick}>
                    <span className="icon-add-family" />
                </button>*/}
            </BackdropWrapper>
        );
    }

}

export default withRouter(MyChartProxyButton);